<template>
  <v-dialog v-bind:value="dialog" @click:outside="$emit('updateDialog', false)" max-width="500px">
    <v-card v-if="node">
      <v-form v-on:submit.prevent="assign">
        <v-card-title>
          <span class="headline">Responsable de {{ node.name }}</span>
        </v-card-title>

        <v-card-text>
          <v-autocomplete
            label="Legajo responsable"
            v-model="legajo"
            :items="legajos"
            :item-text="legajoText"
            item-value="id"
            return-object
            clearable
            :loading="loading_legajos"
            hint="Deje vacío para marcar el puesto como vacante"
            persistent-hint
          ></v-autocomplete>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
          <v-btn color="success" text type="submit" :loading="loading">Guardar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { orgChartService } from "@/libs/ws/orgChartService";
import { legajoService } from "@/libs/ws/legajoService";

export default {
  props: {
    dialog: Boolean,
    node: Object,
  },
  data() {
    return {
      legajo: null,
      legajos: [],
      loading_legajos: false,
      loading: false,
    };
  },
  watch: {
    dialog(value) {
      if (!value) return;
      this.legajo = this.node != null ? this.node.legajo : null;
      if (this.legajos.length == 0) this.loadLegajos();
    },
  },
  methods: {
    legajoText(legajo) {
      return legajo.nro_legajo + " - " + legajo.surname + ", " + legajo.name;
    },
    loadLegajos() {
      this.loading_legajos = true;
      legajoService
        .filter({ status: "linked" })
        .then((response) => {
          if (response.status) this.legajos = response.result;
        })
        .catch((e) => console.log(e))
        .finally(() => (this.loading_legajos = false));
    },
    assign() {
      if (this.loading) return;
      this.loading = true;
      orgChartService
        .assign_responsible({ id: this.node.id, legajo_id: this.legajo != null ? this.legajo.id : null })
        .then((response) => {
          if (response.status) {
            this.$toast.success("El responsable se actualizo correctamente.", "OK");
            this.$emit("updateDialog", false);
            this.$emit("assigned");
          } else {
            this.$toast.error(response.msg, "Error");
          }
        })
        .catch((e) => {
          console.log(e);
          this.$toast.error("Ocurrio un error al asignar el responsable.", "Error");
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
